module.exports = __webpack_public_path__ + "img/ring_r_e_1_null@3x.b288720c.png";